export const isValidUrl = (url?: string) => {
  if (!url) return false;
  return /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w- ./?%&=]*)?$/.test(url);
};
